import { FC, ReactNode, useEffect } from 'react'
import { Button, FlexContainer, MainContainer, Text } from '@reapit/elements'
import { cssMainErrorPage404Container } from './styles'
import { NetworkErrorInfo, useErrorPagesContext } from '@reapit-sales/utilities'
import { GAP_RELOAD_TO_LOGIN_PAGE } from '@crm/constants'
import { useHandleLogout } from '@crm/hooks'

interface UnauthorizedUserPageProps extends NetworkErrorInfo {
  children?: ReactNode
}
export const UnauthorizedUserWrapper: FC<UnauthorizedUserPageProps> = ({ children, ...props }) => {
  const onClickRedirect = useHandleLogout()
  const { errorInfo } = useErrorPagesContext()

  useEffect(() => {
    if (errorInfo.isError && errorInfo.isRedirect) {
      setTimeout(onClickRedirect, GAP_RELOAD_TO_LOGIN_PAGE)
    }
  }, [errorInfo])

  const getErrorInfo = () => ({ ...props, ...errorInfo })

  if (getErrorInfo().isError) {
    return (
      <MainContainer>
        <FlexContainer isFlexGrow1 isFlexAlignCenter isFlexJustifyCenter className={cssMainErrorPage404Container}>
          <Text as="span" colour="secondary" className="el-pb4" size="3xl" weight="regular">
            {getErrorInfo().errorTitle}
          </Text>
          <Text as="span" colour="secondary" className="el-pb8" size="xl" weight="regular">
            {getErrorInfo().errorMessage}
          </Text>

          {getErrorInfo().isRedirect && (
            <Button size="medium" variant="primary" className="el-w-auto" onClick={onClickRedirect}>
              Return to Login
            </Button>
          )}
        </FlexContainer>
      </MainContainer>
    )
  } else {
    return children
  }
}
